import { TFTSMonthlyState } from './types';

export function getTableData(state: TFTSMonthlyState) {
  return state.tableData;
}
